export default __webpack_public_path__ + "2fd25082091bb9f4ddaf1110449b6948.png";